export default [{
        key: 'serial',
        label: 'Serial'
    },
    {
        key: 'item_type.name',
        label: 'Tipo'
    },
    {
        key: 'item_sub_type.name',
        label: 'Subtipo'
    },
    {
        key: 'item_brand.name',
        label: 'Marca'
    },
    {
        key: 'sim_card_number',
        label: 'Número SimCard'
    },
    {
        key: 'munition',
        label: 'Munición'
    },
    {
        key: 'price',
        label: 'Precio'
    },
    {
        key: 'notes',
        label: 'Observaciones'
    },
    {
        key: 'assignation',
        label: 'Asignación'
    },
    {
        key: 'actions',
        label: 'Acciones'
    }
];
